import DropdownOption from "@/entities/DropdownOption";
import getCountryRelatedValue from "@/helpers/locations/getCountryRelatedValue";

function getStateProvinceSelectTitle(countries: DropdownOption[], multiple: boolean = false): string {
  return getCountryRelatedValue({
    countries,
    primary: multiple ? "Provinces or States" : "Province or State",
    onlyUSA: multiple ? "States" : "State",
    onlyCanada: multiple ? "Provinces" : "Province",
    defaultValue: multiple ? "Regions" : "Region",
  });
}

export default getStateProvinceSelectTitle;